module.exports = __webpack_public_path__ + "static/media/80erfinaldemo-01.857f13e6.svg";